import { render, staticRenderFns } from "./app-detail-reflection.vue?vue&type=template&id=a9407a8c";
import script from "./app-detail-reflection.vue?vue&type=script&lang=js";
export * from "./app-detail-reflection.vue?vue&type=script&lang=js";
import style0 from "./app-detail-reflection.vue?vue&type=style&index=0&id=a9407a8c&prod&lang=less";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;